import React from "react"
import Post from '../components/blog-post'
import WuformButton from '../components/wuform-button'
import LayoutDemolition from "../components/layout-demolition"
import SuccessBtnDemolition from "../components/success-btn-demolition"

const PROGUIDEXXXPAGEDEMOLITION = ({ pageContext }) => 
{ 
    const title = pageContext.post.title !== undefined ? pageContext.post.title : '';  
    const post = pageContext.post; 
    const env = pageContext.env;
    const code = pageContext.code;
    
    const seo = 
    {
        url: post.url,
        env: env,
        code: code,
        page: 'guide',
        blog: post
    }

    return (
        <LayoutDemolition seo={seo} code={code} env={env} hidden={true} callToAction={true}>

            <div className="blog">
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{title}</h1>
                            <div className="posts">
                                <Post post={post} />
                            </div>                            
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">                                                 
                                <div className="block">
                                    <WuformButton />
                                </div>
                                <div className="block">                                    
                                    <SuccessBtnDemolition />
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>                         
            </div> 
        </LayoutDemolition>
    )
};

export default PROGUIDEXXXPAGEDEMOLITION;